module.exports = __webpack_public_path__ + "img/f14.59b812a8.jpg";